import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import store from '../src/store';
import { Provider } from 'react-redux';
import "./styles/App.css";
import './main.scss';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import { Controller } from './features/Controller';

Controller.LoadTodaysGame();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
